<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.approve" icon="vxe-icon-check" mode="text" status="success" @click="submit('approve')"/>
        <vxe-button :disabled="order.countingType!==1" content="button.reject" icon="vxe-icon-undo" mode="text" status="error" @click="submit('reject')"/>
      </template>
      <vxe-form ref="order" :data="order" border size="medium" span="8" title-align="center" title-background title-bold>
        <vxe-form-item field="no" title="business.label.orderNo"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:orderStatus,props:{readonly:true}}" field="orderStatus" title="business.label.orderStatus"/>
        <vxe-form-item field="invoiceTime" title="business.label.invoiceTime"/>
        <vxe-form-item field="owner.name" title="business.label.owner"/>
        <vxe-form-item field="operator" title="business.label.operator"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:countingTypes,props:{readonly:true}}" field="countingType" title="business.label.countingType"/>
      </vxe-form>
    </vxe-card>
    <vxe-table ref="table" :data="details" :loading="loading">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="lot.producingArea" title="business.label.producingArea"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="detail.quantity" title="business.label.quantity" width="90"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="detail.inventoryState" title="business.label.inventoryStatus" width="100"/>
      <vxe-column field="detail.reasons" title="business.label.reason"/>
    </vxe-table>
  </div>
</template>

<script>
import { findAll, findOne, post } from '@/api/Api'
import api from '@/api'
import { CountingOrder } from '@/api/dto/order/CountingOrder'

export default {
  name: 'CountingApproveDetail',
  props: {
    orderStatus: {
      type: Array,
      default: []
    },
    inventoryStates: {
      type: Array,
      default: []
    },
    countingTypes: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      order: new CountingOrder(),
      details: [],
      urls: {
        approve: api.countingReview,
        reject: api.countingReject
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(row) {
      this.loading = true
      findOne('countingOrderFactory', { id: row.order.id }).then(res => {
        if (res.success) {
          this.order = new CountingOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('countingDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    },
    submit(type) {
      this.loading = true
      post(this.urls[type], { type: 'inventoryCounter' }, { id: this.order.id }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.back()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>